import './ChooseTemplateWidgetDialog.scss';
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import {WidgetType, WLIST} from "./WEnum";


export default class ChooseTemplateWidgetDialog extends Dialog {
	private _listNode: HTMLElement;

	_initFields(settings: object)
	{

		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._Caption = NP.RM.getString('ChooseWidget');
		this._ShowCloseButton = true;
		this._AutoDestroy = true;
		this._Width = 1000;
		this._ShowButtons = false
	}

	_render()
	{
		super._render();
		this._listNode = NP.createNode(this._contentNode);

		Object.keys(WLIST).forEach((type: WidgetType) =>
		{
			let info = WLIST[type];
			let wnode = NP.createNode(this._listNode, 'template-widget-item') as HTMLElement;
			wnode.innerText = info.Name;
			wnode.classList.add(info.ClassName)
			this.addEvent(wnode, 'click', () => this.onTemplateSelected(type))
		})
	}

	onTemplateSelected(type: WidgetType)
	{
		(new WLIST[type].Class({
			EvOkButtonClick: this.EvOkButtonClick
		})).show()


		this.hide();
	}
}